import React, { useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
const buyers = [{
  name: 'María',
  city: 'Buenos Aires'
}, {
  name: 'Valentina',
  city: 'Córdoba'
}, {
  name: 'Camila',
  city: 'Rosario'
}, {
  name: 'Laura',
  city: 'Mendoza'
}, {
  name: 'Sofía',
  city: 'Tucumán'
}, {
  name: 'Florencia',
  city: 'La Plata'
}, {
  name: 'Daniela',
  city: 'Mar del Plata'
}, {
  name: 'Paula',
  city: 'Salta'
}];
export function LiveNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [timeAgo, setTimeAgo] = useState(3);
  useEffect(() => {
    if (isDismissed) return;
    // Initial delay before showing first notification
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Cycle through notifications
    const cycleInterval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % buyers.length);
        setTimeAgo(Math.floor(Math.random() * 12) + 1); // Random time between 1-12 mins
        setIsVisible(true);
      }, 8000); // Wait 8 seconds before showing next
    }, 12000); // 4s visible + 8s hidden = 12s total cycle
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(cycleInterval);
    };
  }, [isDismissed]);
  if (isDismissed) return null;
  const currentBuyer = buyers[currentIndex];
  return <div className={`fixed z-50 transition-all duration-500 ease-in-out 
        md:bottom-6 md:left-6 md:top-auto top-20 left-4 right-4 md:right-auto
        ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0 pointer-events-none'}`} data-id="element-138">
      <div className="bg-white rounded-xl shadow-card border border-rose/20 p-3 pr-10 flex items-center gap-3 relative max-w-sm mx-auto md:mx-0" data-id="element-139">
        <button onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-text-light hover:text-text-dark transition-colors" aria-label="Cerrar notificación" data-id="element-140">
          <XIcon size={14} data-id="element-141" />
        </button>

        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-rose to-coral flex items-center justify-center text-white font-bold flex-shrink-0" data-id="element-142">
          {currentBuyer.name.charAt(0)}
        </div>

        <div className="flex flex-col" data-id="element-143">
          <div className="flex items-center gap-1.5" data-id="element-144">
            <span className="text-sm font-bold text-text-dark" data-id="element-145">
              {currentBuyer.name} de {currentBuyer.city}
            </span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-146">
            <span className="text-xs text-text-medium" data-id="element-147">
              compró hace {timeAgo} min
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" data-id="element-148"></span>
          </div>
        </div>
      </div>
    </div>;
}